import { a as m, t as h, b as T } from "./en-US-DzLLmR2o.js";
function l(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function d(t, e) {
  var f, c, o, i;
  const r = m(), s = (e == null ? void 0 : e.weekStartsOn) ?? ((c = (f = e == null ? void 0 : e.locale) == null ? void 0 : f.options) == null ? void 0 : c.weekStartsOn) ?? r.weekStartsOn ?? ((i = (o = r.locale) == null ? void 0 : o.options) == null ? void 0 : i.weekStartsOn) ?? 0, n = h(t), a = n.getDay(), u = (a < s ? 7 : 0) + a - s;
  return n.setDate(n.getDate() - u), n.setHours(0, 0, 0, 0), n;
}
function k(t) {
  return d(t, { weekStartsOn: 1 });
}
function D(t) {
  const e = h(t), r = e.getFullYear(), s = l(t, 0);
  s.setFullYear(r + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const n = k(s), a = l(t, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const u = k(a);
  return e.getTime() >= n.getTime() ? r + 1 : e.getTime() >= u.getTime() ? r : r - 1;
}
function g(t) {
  const e = D(t), r = l(t, 0);
  return r.setFullYear(e, 0, 4), r.setHours(0, 0, 0, 0), k(r);
}
function x(t) {
  const e = h(t), r = +k(e) - +g(e);
  return Math.round(r / T) + 1;
}
function F(t, e) {
  var i, w, O, Y;
  const r = h(t), s = r.getFullYear(), n = m(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((w = (i = e == null ? void 0 : e.locale) == null ? void 0 : i.options) == null ? void 0 : w.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((Y = (O = n.locale) == null ? void 0 : O.options) == null ? void 0 : Y.firstWeekContainsDate) ?? 1, u = l(t, 0);
  u.setFullYear(s + 1, 0, a), u.setHours(0, 0, 0, 0);
  const f = d(u, e), c = l(t, 0);
  c.setFullYear(s, 0, a), c.setHours(0, 0, 0, 0);
  const o = d(c, e);
  return r.getTime() >= f.getTime() ? s + 1 : r.getTime() >= o.getTime() ? s : s - 1;
}
function y(t, e) {
  var f, c, o, i;
  const r = m(), s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((c = (f = e == null ? void 0 : e.locale) == null ? void 0 : f.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((i = (o = r.locale) == null ? void 0 : o.options) == null ? void 0 : i.firstWeekContainsDate) ?? 1, n = F(t, e), a = l(t, 0);
  return a.setFullYear(n, 0, s), a.setHours(0, 0, 0, 0), d(a, e);
}
function I(t, e) {
  const r = h(t), s = +d(r, e) - +y(r, e);
  return Math.round(s / T) + 1;
}
const P = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, W = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, C = (t, e) => {
  const r = t.match(/(P+)(p+)?/) || [], s = r[1], n = r[2];
  if (!n)
    return P(t, e);
  let a;
  switch (s) {
    case "P":
      a = e.dateTime({ width: "short" });
      break;
    case "PP":
      a = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = e.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", P(s, e)).replace("{{time}}", W(n, e));
}, E = {
  p: W,
  P: C
}, b = /^D+$/, S = /^Y+$/, _ = ["D", "DD", "YY", "YYYY"];
function N(t) {
  return b.test(t);
}
function R(t) {
  return S.test(t);
}
function J(t, e, r) {
  const s = H(t, e, r);
  if (console.warn(s), _.includes(t)) throw new RangeError(s);
}
function H(t, e, r) {
  const s = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${s} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
export {
  I as a,
  D as b,
  l as c,
  F as d,
  N as e,
  k as f,
  x as g,
  R as i,
  E as l,
  d as s,
  J as w
};
